import React from 'react';
import useRUMView from 'common-datadog/useRUMView';

import Screen from '../Screen';
import DeclinedMerchantCopy from '../DeclinedMerchantCopy';
import DeclinedCTA from '../DeclinedCTA';

const Declined = () => {
  useRUMView('declined');
  return (
    <Screen
      header="Unfortunately, your application could not be approved at this time."
      subheader={<DeclinedMerchantCopy />}
    >
      <DeclinedCTA />
    </Screen>
  );
};

export default Declined;
